import i18n from '~/components/i18n';
import DairyImage from '@assets/svgs/klima/Icon_Molkerei.svg'
import DairyCowImage from '@assets/svgs/klima/Icon_Milchkuh.svg'
import ForageImage from '@assets/svgs/klima/futterbau.jpg'
import CalfManureImage from '@assets/svgs/klima/Icon_Dunger_Farse.svg'
import CowFeedImage from '@assets/svgs/klima/Icon_Futter_Milchkuh.svg'
import CowEnergyImage from '@assets/svgs/klima/Icon_Energie_Milchkuh.svg'
import ResultsImage from '@assets/svgs/klima/Icon_Ergebnis.svg'

export enum StepId {
  MILK = 'milk',
  HERD = 'herd',
  GRAZING = 'grazing',
  FEED = 'feed',
  MANURE = 'manure',
  ENERGY_PROCESSING = 'energy_processing',
  TRANSPORT = 'transport',
  RESULTS = 'result'
}

export const getDairySteps = () => [
  { title: i18n.t('Milk'), id: StepId.MILK, image: DairyImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Herd'), id: StepId.HERD, image: DairyCowImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Grazing'), id: StepId.GRAZING, image: ForageImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Feed'), id: StepId.FEED, image: CowFeedImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Manure'), id: StepId.MANURE, image: CalfManureImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Energy & Processing'), id: StepId.ENERGY_PROCESSING, image: CowEnergyImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Transport'), id: StepId.TRANSPORT, image: DairyImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Results'), id: StepId.RESULTS, image: ResultsImage, style: { marginTop: 16, width: 32 } }
];

export const HERD_GROUP_ERROR_CLASS = 'error-herd-group'

export const MILK_COWS_SLUG = 'milk_cows'